module.exports = __webpack_public_path__ + "img/otccce.d7330474.svg";